"use strict";
exports.__esModule = true;
exports.PAY_NOW_CONTENT = void 0;
exports.PAY_NOW_CONTENT = {
    FLEX_ANYWHERE: {
        HEADER: 'Make your 1st payment',
        BODY: 'After you make your 1st payment, we’ll provide the Flex {{paymentMethod}} details to submit your rent in your property’s portal.',
        AMOUNT_LABEL: '1st payment',
        SUCCESS_BODY_ONE: 'You’ve completed your 1st payment of {{rentAmount}}.',
        SUCCESS_BODY_TWO: 'Now you can use the Flex {{paymentMethod}} to submit your rent to your property.'
    },
    PAYMENT_LIMIT_RETRY: {
        HEADER: 'Too many attempts',
        BODY: 'You’re no longer able to make this payment because you’ve tried too many times. We’ll automatically process this payment as scheduled on {{paymentDate}}.',
        CTA: 'Close'
    },
    GENERIC_PAYMENT_FAILURE: {
        TEXT_1: 'We couldn’t complete your payment of {{paymentAmount}} due to an issue with your card or bank.',
        TEXT_2: 'You can try the payment again, or change your payment card.',
        TEXT_3: 'To use Flex this month, your payment must be completed by {{retryTime}} ET on {{retryDateString}}.'
    },
    FUND_EARLY: {
        FUND_EARLY_DISCLAIMER: '👆 This payment is based on your total estimated rent of {{estimatedRent}}. If your rent bill is higher than estimated, we’ll charge the difference in a separate transaction.'
    }
};
